<template>
  <!--      Modal Actual -->
  <b-modal
    id="print-deposit-note"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    title="Print Commission Invoice"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <section>
        <b-card
          id="invoice-preview-card"
          no-body
          class="invoice-preview-card"
        >
          <b-card-body
            class="invoice m-2"
          >
            <b-row class="invoice-spacing">

              <!-- Col: Invoice To -->
              <b-col
                cols="12"
                class="pb-1"
              >
                <h4 class="pb-1">
                  Agent Commission Invoice
                </h4>
                <h6>
                  Agent Name:  {{ allData.agency.name }}
                </h6>
                <h6>
                  Invoice Date:  {{ formatDate(allData.created_at) }}
                </h6>
                <h6>
                  Status:  {{ allData.status.name }}
                </h6>
              </b-col>
            </b-row>
            <b-table
              striped
              bordered
              responsive
              :items="rows"
              :fields="fields"
              show-empty
            >
              <template #cell(commission)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
            </b-table>
            <b-row>
              <b-col
                cols="12"
                md="12"
                class="pt-1"
              >
                <div>
                  <table class="col-12">
                    <tbody>
                      <tr>
                        <td class="pr-1">
                          Total Deposits:
                        </td>
                        <td class="text-right">
                          <span>{{ __numberWithCommas(allData.total_deposit_count) || '0' }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          Total Commission:
                        </td>
                        <td class="text-right">
                          <span>{{ currency_type }} {{ __numberWithCommas(allData.total_commission_amount, true) || '0' }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          <h6 class="font-weight-bold">
                            NET Payable:
                          </h6>
                        </td>
                        <td class="text-right">
                          <span class="font-weight-bold">{{ currency_type }} {{ __numberWithCommas(allData.total_commission_amount, true) || '0' }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <!-- Right Col: Card -->
        <b-col
          cols="12"
          md="4"
          xl="4"
        >
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-success"
            class="mb-75"
            block
            @click="printDepositNote"
          >
            <feather-icon
              icon="PrinterIcon"
            />
            Print
          </b-button>
        </b-col>
      </section>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BCard,
  BButton,
  BModal,
  BCol,
  BCardBody,
  BRow,
  BOverlay,
  VBModal,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const FinanceRepository = RepositoryFactory.get('finance')

function initialState() {
  return {
    open: false,
    modalLoading: false,
    id: '',
    fields: [
      {
        key: 'ref_no',
        label: 'Agent Deposit Ref Number',
      },
      {
        key: 'commission',
        label: 'Commission Total',
        tdClass: 'text-right',
        thClass: 'text-right',
      },
    ],
    rows: [],
    allData: {
      agency: {},
    },
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCard,
    BButton,
    BModal,
    BCol,
    BCardBody,
    BRow,
    BOverlay,
    BTable,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  methods: {
    async openModal(id) {
      await Object.assign(this.$data, initialState())
      this.open = true
      this.id = id
      this.getAgentCommissionNote()
    },
    formatDate(dateString) {
      return dateString.replace(/^(\d{4})-(\d{2})-(\d{2})T.*$/, '$1-$2-$3')
    },
    async getAgentCommissionNote() {
      this.modalloading = true
      try {
        const { data } = (await FinanceRepository.getAgentCommissionNote(this.id)).data
        this.rows = data.deposits
        this.allData = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    printDepositNote() {
      const modal = document.getElementById('invoice-preview-card')
      const cloned = modal.cloneNode(true)
      let section = document.getElementById('print')

      if (!section) {
        section = document.createElement('div')
        section.id = 'print'
        document.body.appendChild(section)
      }

      section.appendChild(cloned)
      window.print()
      section.innerHTML = ''
    },
  },
}
</script>
<style lang="scss">
@page {
  width: 80mm;
}
@media screen {
  #print {
    display: none;
  }
}
@media print {
  body * {
    visibility:hidden;
  }
  #print, #print * {
    visibility:visible;
  }
  #print {
    position:absolute;
    left:0;
    top:0;
    width: 100%;
  }
}
</style>
<style scoped>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/fabric.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/fabric.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/fabric.css";
</style>
